import "./productList.css";
import Product from "../product/Product";
import { products } from "../../data";

const ProductList = () => {

  return (
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">Learn From everyone, follow no one. It's Fariha</h1>
        <p className="pl-desc">
          Prefer to Challange my limits rather than limit challenges
        </p>
        <h4 className="pl-project">Projects</h4>
        <p>__________________</p>
      </div>
      <div className="pl-list">
        {products.map((item) => (
          <>
            
          <Product key={item.id} img={item.img} link={item.link} name={item.name} technology={item.technology}/>
          </>
       
        ))}
      </div>
    </div>
  );
};

export default ProductList;
